var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectButton',_vm._g(_vm._b({attrs:{"id":_vm.computedId,"optionLabel":_vm.optionLabel,"optionValue":_vm.optionValue,"value":_vm.value}},'SelectButton',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }